import { api } from './auth';

export async function getFavorites(dataType) {
  const res = await api.get('/favorites/', { params: { data_type: dataType } });
  return res.data;
}

export async function addFavorite(dataType, dataId) {
  const res = await api.post('/favorites/', { data_type: dataType, data_id: dataId });
  return res.data;
}

export async function removeFavorite(dataType, dataId) {
  const res = await api.delete('/favorites/', { params: { data_type: dataType, data_id: dataId } });
  return res.data;
}

// Notifications
export async function getNotifications() {
  const res = await api.get('/notifications/');
  return res.data;
}

export async function markNotificationRead(notifId) {
  const res = await api.patch(`/notifications/${notifId}/read`, {});
  return res.data;
}

export async function deleteNotification(notifId) {
  const res = await api.delete(`/notifications/${notifId}`);
  return res.data;
} 